import { gql } from 'apollo-angular';

export const userAvailability = gql`
	fragment UserAvailability on UserAvailabilityOutput {
		id
		type
		dayIndex
		endOffset
		startOffset
	}
`;

export const userContactCompany = gql`
	fragment UserContactCompany on UserContactCompanyOutput {
		id
		name
		userId
	}
`;

export const userReference = gql`
	fragment UserReference on UserReferenceOutput {
		id
		name
		type
		endDate
		startDate
		institution
	}
`;

export const userMetadata = gql`
	fragment UserMetadata on UserMetadataOutput {
		quote
		isGhost
		language
		birthDate
		linkedInUrl
		birthAddress
		moodFrequency
		currentAddress
		moodDescriptionShown
		registrationTimestamp
	}
`;

export const usersOrganization = gql`
	fragment UsersOrganization on OrganizationOutput {
		id
		name
		sectors
		logoUrl
		iconUrl
		updateTimestamp
		creationTimestamp
		planPrice {
			amount
			currency
		}
		sessionPrice {
			amount
			currency
		}
		style {
			primaryColor
		}
		shortDescription
		paymentProviderSubscriptionId
	}
`;

export const userOrganization = gql`
	fragment UserOrganization on OrganizationOutput {
		...UsersOrganization
		description
		properties {
			name
			type
			value
		}
		style {
			primaryColor
		}
	}
	${usersOrganization}
`;

export const usersCoach = gql`
	fragment UsersCoach on UserOutput {
		id
		role
		hasMfa
		status
		timeZone
		lastName
		firstName
		avatarUrl
		phoneNumber
		emailAddress
		updateTimestamp
		creationTimestamp
		organization {
			...UserOrganization
		}
	}
	${userOrganization}
`;

export const userMfaEngage = gql`
	fragment UserMfaEngage on UserMfaEngageOutput {
		account
		issuer
		qrCodeImageUri
		secret
	}
`;

export const userCoach = gql`
	fragment UserCoach on UserOutput {
		...UsersCoach
		references {
			...UserReference
		}
		metadata {
			...UserMetadata
		}
		organization {
			...UserOrganization
		}
	}
	${userOrganization}
	${userReference}
	${userMetadata}
	${usersCoach}
`;

export const user = gql`
	fragment User on UserOutput {
		id
		role
		hasMfa
		status
		timeZone
		lastName
		firstName
		avatarUrl
		partnersId
		phoneNumber
		observersId
		emailAddress
		intercomHash
		updateTimestamp
		creationTimestamp
		partners {
			partnerRights {
				access
				target
			}
			organizationId
			userId
		}
		coach {
			...UserCoach
		}
		organization {
			...UserOrganization
		}
		metadata {
			...UserMetadata
		}
		references {
			...UserReference
		}
		availabilities {
			...UserAvailability
		}
	}
	${userCoach}
	${userMetadata}
	${userReference}
	${userAvailability}
	${userOrganization}
`;

export const users = gql`
	fragment Users on UserOutput {
		id
		role
		hasMfa
		status
		timeZone
		lastName
		firstName
		avatarUrl
		partnersId
		phoneNumber
		observersId
		emailAddress
		intercomHash
		updateTimestamp
		creationTimestamp
		coach {
			...UsersCoach
		}
		organization {
			...UsersOrganization
		}
		metadata {
			...UserMetadata
		}
	}
	${usersCoach}
	${userMetadata}
	${usersOrganization}
`;
